
import Vue from 'vue'
let comsys= {
  install(Vue){
    Vue.prototype.comsys = {
      targetURL:function(val){
        return val
      }
    };

  }
}
Vue.use(comsys);
